import { render, staticRenderFns } from "./PosterHostCard.vue?vue&type=template&id=583431dc&scoped=true"
import script from "./PosterHostCard.vue?vue&type=script&lang=js"
export * from "./PosterHostCard.vue?vue&type=script&lang=js"
import style0 from "./PosterHostCard.vue?vue&type=style&index=0&id=583431dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583431dc",
  null
  
)

export default component.exports